import { useNavigate } from "react-router-dom";
import { BoxInner, TextBox } from "style/admin/layout";

interface CalibrationCreateModalProps {
  closedHandler: () => void;
}

export function CalibrationCreateModal({ closedHandler }: CalibrationCreateModalProps) {
  const navigate = useNavigate();
  const clickHandler = () => {
    closedHandler();
    navigate(`/admin/calibration`);
  };
  return (
    <BoxInner>
      <TextBox style={{ minHeight: "auto" }}>
        <p>캘리브레이션가 등록되었습니다.</p>
        <span>확인을 클릭하면 캘리브레이션 리스트로 돌아갑니다.</span>
      </TextBox>
      <div className="btn-box">
        <button className="continue" onClick={clickHandler}>
          확인
        </button>
      </div>
    </BoxInner>
  );
};
